<template>
  <v-row
    v-if="list.length > 0"
    class="d-flex justify-space-between align-left my-6"
  >
    <v-col cols="12" lg="6">
      <div
        class="btn"
        tabindex="0"
        role="button"
        @keypress="prev()"
        @click="prev()"
        title="上則公告"
      >
        <v-icon left> mdi-arrow-left</v-icon>
        <span>上則公告</span>
        <ListItem
          :key="'prev_' + Date.now()"
          :item="list[setPrevIdx()]"
          :download="false"
        />
      </div>
    </v-col>

    <v-col cols="12" lg="6">
      <div
        class="btn"
        tabindex="0"
        role="button"
        @keypress="next()"
        @click="next()"
        title="下則公告"
      >
        <v-icon left> mdi-arrow-right</v-icon>
        <span>下則公告</span>
        <ListItem
          :key="'next_' + Date.now()"
          :item="list[setNextIdx()]"
          :download="false"
        />
      </div>
    </v-col>
  </v-row>
</template>
<script>
import ListItem from "@/components/ui/searchList/ListItem.vue";
export default {
  components: {
    ListItem
  },
  props: {
    pageName: {
      type: String,
      default: ""
    },
    idx: {
      type: [String, Number],
      default: 0
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    setPrevIdx() {
      let idx = this.idx;
      idx--;
      if (idx < 0) idx = this.list.length - 1;
      return idx;
    },
    setNextIdx() {
      let idx = this.idx;
      idx++;
      if (idx >= this.list.length) idx = 0;
      return idx;
    },
    prev() {
      let idx = this.idx;
      idx--;
      if (idx < 0) idx = this.list.length - 1;
      //this.item = this.list[idx];
      this.$emit("item", this.list[idx]);
      this.$emit("idx", idx);
      //this.idx = idx;
      //this.prevA = true;
      this.SYS.goToDetails(
        this.list[idx],
        idx,
        this.list,
        this.pageName
        //this.$router
      );
    },
    next() {
      let idx = this.idx;
      idx++;
      if (idx >= this.list.length) idx = 0;
      //this.item = this.list[idx];
      this.$emit("item", this.list[idx]);
      this.$emit("idx", idx);
      //this.idx = idx;
      //this.prevA = false;
      this.SYS.goToDetails(
        this.list[idx],
        idx,
        this.list,
        this.pageName
        //this.$router
      );
    }
  }
};
</script>
